<div class="cell-wrapper">
  @if (collateralsToDisplay?.nonCash && locateMatch?.nonCashMatch) {
  <ng-container nonCash *ngTemplateOutlet="unitsTpl; context: { $implicit: locateMatch.nonCashMatch}"></ng-container>
  } @if (collateralsToDisplay?.cash && locateMatch?.cashMatch) {
  <ng-container cash *ngTemplateOutlet="unitsTpl; context: { $implicit: locateMatch.cashMatch}"></ng-container>
  }
</div>
<ng-template #unitsTpl let-collateralSpecificMatch>
  <div class="sg-pos-rel" [ngClass]="{ 'updated-cell': collateralSpecificMatch.form.controls.units.pristine && collateralSpecificMatch.unitsUpdated }">
    <ng-container
      *ngTemplateOutlet="hasMultipleEntities ? unitsWithEntityInput : onlyUnitsInput; context: { $implicit: collateralSpecificMatch }"></ng-container>
    @if (collateralSpecificMatch.unitsRequestedQtyOverAvailable) {
    <span class="sg-partial-match-message" [class.with-legal-entity]="hasMultipleEntities" data-test="partial-match-qty-message">Limited availability</span>
    } @if (collateralSpecificMatch.unitsRequestedValueBelowMin) {
    <span class="sg-partial-match-message" [class.with-legal-entity]="hasMultipleEntities" data-test="partial-match-value-message">Units not as requested</span>
    }
  </div>
</ng-template>
<ng-template #unitsWithEntityInput let-collateralSpecificMatch>
  <sg-borrower-entity-input
    [class.partial-highLight]="collateralSpecificMatch.unitsRequestedQtyOverAvailable"
    [withFormControl]="collateralSpecificMatch.form.controls.units"
    [revertTooltipMsg]="'Revert to available units'"
    [availability]="collateralSpecificMatch.matchUnits"
    [errorValidatorsMessages]="validationErrorMessages[collateralSpecificMatch.type]"
    [session]="session"
    (selectionChange)="selectionChange.emit({ collateralSpecificMatch, selectedLegalEntity: $event })"
    (onBlurRow)="reset.emit(collateralSpecificMatch)"></sg-borrower-entity-input>
</ng-template>
<ng-template #onlyUnitsInput let-collateralSpecificMatch>
  <sg-borrower-input
    [class.partial-highLight]="collateralSpecificMatch.unitsRequestedQtyOverAvailable"
    [withFormControl]="collateralSpecificMatch.form.controls.units"
    [revertTooltipMsg]="'Revert to available units'"
    [errorValidatorsMessages]="validationErrorMessages[collateralSpecificMatch.type]"
    (onBlurRow)="reset.emit(collateralSpecificMatch)"></sg-borrower-input>
</ng-template>
